export default async function getArticleCount($http, path) {
  return await $http.get(path);
}



// WEBPACK FOOTER //
// ./src/utils/getArticleCount.js